// import { createSelector } from 'reselect';

export const selectAllTaxes = (state:any) => state.taxes.taxes;
export const selectTax = (state:any) => state.taxes.tax;
export const selectIsLoading = (state:any) => state.taxes.isLoading;
export const selectStatus = (state:any) => state.taxes.status;
